import React from 'react'
import { IPublishedGraphic } from '../../types/publishedGraphic'
import { topicsTypeaheadToFormAdapter } from '../../services/typeahead'
import { Space } from '../../layouts'
import { H3, P, TooltipedChip } from '../../components'
import { PublishedGraphicActions } from './PublishedGraphicActions'
import { PublishedGraphicCopyLynxEditorLink } from './PublishedGraphicCopyLynxEditorLink'
import { OrangeText } from './styled'

interface IPublishedGraphicSidebar {
  publishedGraphic: IPublishedGraphic
}

export const PublishedGraphicSidebar = ({
  publishedGraphic,
}: IPublishedGraphicSidebar) => {
  const transformedTopics = publishedGraphic.topicCodes.map(
    topicsTypeaheadToFormAdapter
  )
  return (
    <Space pl={4} pr={4}>
      <Space mb={6}>
        <H3 mb={2}>
          Lynx <OrangeText>Editor</OrangeText>
        </H3>
        <P mb={4} id="sidebar-lynx-editor-description">
          Copy the link to this graphic and paste it into the related links
          section.
        </P>
        <PublishedGraphicCopyLynxEditorLink
          publishedGraphic={publishedGraphic}
        />
      </Space>
      <Space mb={6}>
        <H3 mb={2}>Published link</H3>
        <P mb={4} id="sidebar-description">
          Suggested for Eikon and sharing on social media.
        </P>
        <PublishedGraphicActions publishedGraphic={publishedGraphic} />
      </Space>
      <Space mb={6}>
        <H3 mb={2} id="sidebar-topics-title">
          Topics
        </H3>
        {transformedTopics.map(({ rcsId, label, shortName }) => (
          <TooltipedChip
            value={rcsId}
            tooltipTitle={shortName}
            label={label}
            key={label}
          />
        ))}
      </Space>
    </Space>
  )
}
